<app-navbar></app-navbar>
<router-outlet></router-outlet>
<ng-http-loader [spinner]="spinkit.skChasingDots" [backgroundColor]="'#e84b98'"></ng-http-loader>